document.querySelectorAll('.mobile-sidebar-button').forEach(function (button) {
    const wrapper = document.querySelector('.wrapper');
    button.addEventListener('click', e => {
        e.preventDefault();
        wrapper.classList.toggle('mobile-sidebar-open');
    });
});